import React from 'react';
import { useTranslation } from 'react-i18next';
import sproutlySmartParenting from '../assets/images/sproutly_smart_parenting.png';

const About: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div id="about" className="section-about-area">
            <div className="padding-global">
                <div className="container-large">
                    <div className="padding-section-large padding-bottom-medium">
                        <div className="about-area-component">
                            <div className="w-layout-grid about-grid">
                                {/* Left - Image */}
                                <div id="w-node-_18bf359c-f3e7-053a-1553-dcc71f2a9355-a3567296" className="about-image-wrapper">
                                    <img
                                        src={sproutlySmartParenting}
                                        loading="lazy"
                                        alt="Sproutly AI - Smart Parenting"
                                        className="about-image"
                                    />
                                    <img
                                        src="https://cdn.prod.website-files.com/65d1995bebc2cbfa914e45d5/65d44390fb16aa901aeac204_Cow%2001.svg"
                                        loading="lazy"
                                        alt=""
                                        className="about-decoration-image"
                                        style={{
                                            position: 'absolute',
                                            bottom: '-10%',
                                            left: '-10%',
                                            width: '120px',
                                            height: '120px'
                                        }}
                                    />
                                </div>

                                {/* Right - Content */}
                                <div id="w-node-_1f3567dc-5acb-b9d6-ad84-06772c786265-a3567296" className="about-content-wrapper">
                                    <div className="heading-wrapper">
                                        <h2 className="heading-style-h2">{t('about.title1')}</h2>
                                        <div className="line-color-pink _01" style={{ width: '100%', height: '15px' }}></div>
                                    </div>
                                    <div className="heading-wrapper">
                                        <h2 className="heading-style-h2">{t('about.title2')}</h2>
                                        <div className="line-color-light-golden _02" style={{ height: '14.3984px' }}></div>
                                    </div>
                                    <div className="padding-bottom padding-xxsmall"></div>
                                    <p className="text-size-small">
                                        {t('about.paragraph1')}
                                        <br /><br />
                                        {t('about.paragraph2')}
                                        <br /><br />
                                        {t('about.paragraph3')}
                                    </p>
                                    <div className="padding-bottom padding-small"></div>
                                    <a href="#download" className="button w-button">{t('about.joinButton')}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
